import { request, gql } from "graphql-request";

export default function useProductQuery() {
    const productQuery = gql`
        fragment ProductVariant on ProductVariant {
            id
            image {
                url
            }
            selectedOptions {
                name
                value
            }
            title
            quantityAvailable
            price {
                amount
                currencyCode
            }
            product {
                title
            }
            quantityAvailable
            currentlyNotInStock
            deliveryTime: metafield(namespace: "custom_fields", key: "lieferzeit") {
                id
                value
                type
            }
            deliveryTimeUnit: metafield(namespace: "custom_fields", key: "w_or_d") {
                id
                value
                type
            }
        }

        query fetchProductByHandle(
            $language: LanguageCode!
            $country: CountryCode!
            $handle: String!
        ) @inContext(language: $language, country: $country) {
            product(handle: $handle) {
                title
                options {
                    id
                    name
                    values
                }
                deliveryTime: metafield(namespace: "custom_fields", key: "lieferzeit") {
                    id
                    value
                    type
                }
                deliveryTimeUnit: metafield(namespace: "custom_fields", key: "w_or_d") {
                    id
                    value
                    type
                }
                variants(first: 100) {
                    nodes {
                        ...ProductVariant
                    }
                }
            }
        }
    `;

    return (handle: string, language: string, country: string) => {
        return request({
            url: "/api/2023-07/graphql.json",
            document: productQuery,
            variables: {
                language,
                handle,
                country,
            },
            requestHeaders: {
                "X-Shopify-Storefront-Access-Token": process.env.VUE_APP_STOREFRONT_KEY,
            },
        });
    };
}
